import { render, staticRenderFns } from "./ParcelsTableUser.vue?vue&type=template&id=2ee02a10&scoped=true"
import script from "./ParcelsTableUser.vue?vue&type=script&lang=js"
export * from "./ParcelsTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee02a10",
  null
  
)

export default component.exports